import {useState} from 'react';

import {DeleteForever, PersonAddAlt1, PersonRemove} from '@mui/icons-material';
import {Box, Grid, ListItemIcon, Menu, MenuItem, Typography} from '@mui/material';
import {string, arrayOf} from 'prop-types';

import useProfile from '../../../hooks/providers/useProfile';
import useProjects from '../../../hooks/providers/useProjects';
import {userShape} from '../../../proptypes-shapes';
import UsersChipsList from '../../users/UsersChipsList';
import TitleWithTooltip from '../TitleWithTooltip';

const ProjectUsersList = ({title, titleTooltip, subtitle = '', users}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const isSelectedUserPending = selectedUser?.includes('pending-user');
  const {profile} = useProfile();
  const {isUserActionSubmitting: isSubmitting, openDeleteUserModal, openPromoteUserModal, promoteOrDemote} = useProjects();

  const open = Boolean(anchorEl);

  const isOwnersList = users.every(user => user.is_owner);
  const isOnlyOwner = isOwnersList && users.length === 1 && users[0].user_id.toLowerCase() === profile.id;

  const openMenu = (event, userId) => {
    setAnchorEl(event.target);
    setSelectedUser(userId);
  };

  const closeMenu = () => {
    setAnchorEl(null);
    setSelectedUser(null);
  };

  const deleteUser = userId => {
    openDeleteUserModal(userId);
    closeMenu();
  };

  const onPromote = () => {
    closeMenu();
    openPromoteUserModal(selectedUser);
  };

  const onDemote = async () => {
    closeMenu();
    await promoteOrDemote(selectedUser, false);
  };

  return (
    <Box mb={2}>
      <Grid container alignItems="center" mb={2}>
        <TitleWithTooltip title={title} tooltip={titleTooltip} />
      </Grid>

      {subtitle && (
        <Typography sx={{mt: 0.5, mb: 1}} variant="caption" color="text.secondary">
          {subtitle}
        </Typography>
      )}

      <UsersChipsList users={users} onClick={openMenu} onDelete={deleteUser} isDisabled={isSubmitting || isOnlyOwner} selectedUserId={selectedUser} showDeleteIcon />

      <Menu id="user-menu" anchorEl={anchorEl} open={open} onClose={closeMenu} anchorOrigin={{vertical: 'bottom', horizontal: 'right'}} transformOrigin={{vertical: 'top', horizontal: 'right'}}>
        <MenuItem disabled={isSelectedUserPending} onClick={isOwnersList ? onDemote : onPromote}>
          <ListItemIcon>{isOwnersList ? <PersonRemove fontSize="small" /> : <PersonAddAlt1 fontSize="small" />}</ListItemIcon>
          <Typography variant="inherit">{isOwnersList ? 'Retirer des propriétaires' : 'Rendre propriétaire de la connexion'}</Typography>
        </MenuItem>
        <MenuItem onClick={() => deleteUser(selectedUser)}>
          <ListItemIcon>
            <DeleteForever fontSize="small" color="error" />
          </ListItemIcon>
          <Typography color="error.main" variant="inherit">
            Supprimer l'utilisateur
          </Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
};

ProjectUsersList.propTypes = {
  title: string.isRequired,
  titleTooltip: string.isRequired,
  subtitle: string,
  users: arrayOf(userShape).isRequired
};

export default ProjectUsersList;
